import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/about-us.css";

const ICONS = {
  users:
    '<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c.4-3.6 3-5.5 6.5-5.5s6.1 1.9 6.5 5.5"/><path d="M16 4.8a3.4 3.4 0 0 1 0 6.4M18 14.8c2 .6 3.3 2.3 3.5 5.2"/>',
  brief:
    '<rect x="3" y="7" width="18" height="13" rx="3"/><path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7M3 13h18"/>',
  cal: '<rect x="3.5" y="5" width="17" height="15" rx="3"/><path d="M8 3v4M16 3v4M3.5 10h17"/>',
  globe:
    '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18"/>',
  cloud:
    '<path d="M7 18a4.5 4.5 0 0 1-.6-8.96A6 6 0 0 1 18 9.5 4.3 4.3 0 0 1 17.5 18z"/>',
  shield:
    '<path d="M12 3l7.5 3v5.5c0 4.5-3.1 8-7.5 9.5-4.4-1.5-7.5-5-7.5-9.5V6z"/><path d="M8.8 12l2.3 2.3 4.2-4.6"/>',
  headset:
    '<path d="M4 14v-2a8 8 0 0 1 16 0v2"/><rect x="3" y="14" width="4.5" height="6" rx="2"/><rect x="16.5" y="14" width="4.5" height="6" rx="2"/><path d="M19 20c0 1-1.5 1.8-4 1.8"/>',
  server:
    '<rect x="3.5" y="4" width="17" height="6.5" rx="2"/><rect x="3.5" y="13.5" width="17" height="6.5" rx="2"/><path d="M7.5 7.2h.01M7.5 16.8h.01M12 7.2h5M12 16.8h5"/>',
  chart: '<path d="M4 20V4M4 20h16"/><path d="M8 15l3.5-4 3 2.5L19 7"/>',
  target:
    '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.2"/>',
  eye: '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>',
  check: '<circle cx="12" cy="12" r="9"/><path d="M8 12.5l3 3 5-6"/>',
  arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
  download: '<path d="M12 4v11M7.5 10.5L12 15l4.5-4.5M5 20h14"/>',
  crumb: '<path d="M9 6l6 6-6 6"/>',
  award:
    '<circle cx="12" cy="9" r="5.5"/><path d="M8.5 13.5L7 21l5-3 5 3-1.5-7.5"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  zap: '<path d="M13 3L5 13.5h6L10 21l9-11h-6.5z"/>',
  lock: '<rect x="4.5" y="10.5" width="15" height="10" rx="3"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5M12 14.5v2.5"/>',
  layers:
    '<path d="M12 3l9 5-9 5-9-5z"/><path d="M3 12.5l9 5 9-5M3 16.5l9 5 9-5"/>',
  file: '<path d="M7 3h7l4 4v14H7z"/><path d="M14 3v4h4M10 12h5M10 16h5"/>',
  pin: '<path d="M12 21s7-5.6 7-11a7 7 0 0 0-14 0c0 5.4 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/>',
  linkedin:
    '<rect x="3" y="3" width="18" height="18" rx="4"/><path d="M8 10.5V16M8 7.8v.1M11.5 16v-3a2 2 0 0 1 4 0v3M11.5 10.5V16"/>',
};

// ---------------- SAMPLE CONTENT: edit freely ----------------
const FACTS = [
  {
    icon: "users",
    value: 150,
    suffix: "+",
    label: "Happy clients",
  },
  {
    icon: "brief",
    value: 400,
    suffix: "+",
    label: "Projects delivered",
  },
  {
    icon: "award",
    value: 8,
    suffix: "+",
    label: "Years of experience",
  },
  {
    icon: "globe",
    value: 1,
    suffix: "",
    label: "Office: USA",
  },
];

const SERVICES = [
  {
    icon: "server",
    title: "Managed IT",
    text: "Proactive monitoring, patching and helpdesk so your systems stay healthy and your team stays productive.",
    to: "/services/managed-it",
  },
  {
    icon: "headset",
    title: "IT Support",
    text: "Fast, friendly support from real engineers, whenever your people hit a problem.",
    to: "/services/it-support",
  },
  {
    icon: "chart",
    title: "IT Consultancy",
    text: "Clear technology roadmaps, audits and budgeting that match your business goals.",
    to: "/services/it-consultancy",
  },
  {
    icon: "cloud",
    title: "Cloud Computing",
    text: "Migration, hosting and cost optimisation across the major cloud platforms.",
    to: "/services/cloud-computing",
  },
  {
    icon: "shield",
    title: "Cyber Security",
    text: "Layered protection, monitoring and response that keeps threats out and data safe.",
    to: "/services/cyber-security",
  },
  {
    icon: "layers",
    title: "Network and Infrastructure",
    text: "Reliable networks, Wi-Fi and hardware designed, installed and maintained for you.",
    to: "/services/managed-it",
  },
];

const WHY = [
  {
    icon: "zap",
    title: "Fast response",
    text: "Quick triage and clear communication, so small issues never become big ones.",
  },
  {
    icon: "lock",
    title: "Security first",
    text: "Every solution is designed with protection, backups and compliance built in.",
  },
  {
    icon: "users",
    title: "Dedicated experts",
    text: "Certified engineers who know your environment, not a different voice every call.",
  },
  {
    icon: "globe",
    title: "Two time zones",
    text: "Teams in the USA give you real coverage across the working day.",
  },
  {
    icon: "chart",
    title: "Clear pricing",
    text: "Straightforward plans and honest reporting. No surprises on the invoice.",
  },
  {
    icon: "award",
    title: "Built to last",
    text: "Documented, standards-based work that keeps running long after go-live.",
  },
];

const STEPS = [
  {
    title: "Discover",
    text: "We listen first, audit your current setup and learn how your business really runs.",
  },
  {
    title: "Plan",
    text: "We design a practical roadmap with clear scope, timelines and costs.",
  },
  {
    title: "Deliver",
    text: "Our engineers implement, test and migrate with minimal disruption to your team.",
  },
  {
    title: "Support",
    text: "We monitor, improve and report, so your technology keeps getting better.",
  },
];

const TIMELINE = [
  {
    year: "2017",
    title: "We started in Austin",
    text: "A small team of engineers set out to give local businesses dependable IT support.",
  },
  {
    year: "2019",
    title: "First enterprise clients",
    text: "Managed IT contracts with growing companies shaped our service model.",
  },
  {
    year: "2021",
    title: "Cloud and security practice",
    text: "We added cloud and cyber security specialists as the team grew past 25.",
  },
  {
    year: "2023",
    title: "Austin office opens",
    text: "A new base in Texas brought us closer to our US clients and extended our support hours.",
  },
  {
    year: "2025",
    title: "One country, one team",
    text: "Today 40+ experts support clients across the USA.",
  },
];

// Add `photo: teamPhoto` (an imported image) to show a real photo instead of the initials badge
const TEAM = [
  {
    role: "Founder and CEO",
    name: "Syed Asif",
    bio: "Leads vision, client relationships and company strategy.",
    linkedin: "#",
  },
  {
    role: "Chief Technology Officer",
    name: "Vijay S.",
    bio: "Owns architecture, cloud and security practice.",
    linkedin: "#",
  },
  {
    role: "Head of Digital Marketing",
    name: "Arsalan S.",
    bio: "Runs delivery, support and the Austin team.",
    linkedin: "#",
  },
  {
    role: "Director, USA",
    name: "J. Miller",
    bio: "Leads growth and client success from Austin.",
    linkedin: "#",
  },
];

const VALUES = [
  "Integrity",
  "Ownership",
  "Clear communication",
  "Continuous learning",
];
const BROCHURE_POINTS = [
  "Services overview",
  "Company story",
  "Leadership and office",
];
const BROCHURE_URL = "/gt9_brochure.pdf"; // put the PDF in your /public/brochure folder

function Icon({ name, sw = 1.8 }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: ICONS[name] }}
    />
  );
}

const initials = (name) =>
  name
    .replace(/\./g, "")
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

/* Counts up from 0 the first time it scrolls into view. Shows the final number straight away without JS or with reduced motion. */
function CountUp({ to }) {
  const [n, setN] = useState(to);
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (
      !el ||
      !("IntersectionObserver" in window) ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    )
      return;
    let raf;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        io.disconnect();
        const t0 = performance.now();
        const tick = (t) => {
          const p = Math.min((t - t0) / 1400, 1);
          setN(Math.round(to * (1 - Math.pow(1 - p, 3))));
          if (p < 1) raf = requestAnimationFrame(tick);
        };
        setN(0);
        raf = requestAnimationFrame(tick);
      },
      { threshold: 0.4 },
    );
    io.observe(el);
    return () => {
      io.disconnect();
      cancelAnimationFrame(raf);
    };
  }, [to]);
  return <span ref={ref}>{n}</span>;
}

export default function About() {
  useEffect(() => {
    const previous = document.title;
    document.title = "About us - Global Tech9 LLC";
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <main className="gt9-ab">
      {/* Hero with image */}
      <section className="gt9-ab__hero">
        <img
          className="gt9-ab__hero-img"
          src="/assets/images/about/hero.jpg"
          alt=""
          fetchPriority="high"
        />
        <div className="gt9-container">
          <ol className="gt9-crumbs" aria-label="Breadcrumb">
            <li>
              <Link to="/">Home</Link>
              <Icon name="crumb" sw={2.2} />
            </li>
            <li aria-current="page">About us</li>
          </ol>
          <span className="gt9-eyebrow">About Global Tech9 LLC</span>
          <h1 className="gt9-ab__title">
            Technology partners you can <span className="hl">rely on</span>
          </h1>
          <p className="gt9-ab__lead">
            From Remote location to Austin, we help growing businesses run on
            secure, modern and dependable IT, backed by people who answer the
            phone.
          </p>
          <div className="gt9-actions">
            <Link to="/contact-us" className="gt9-btn gt9-btn--gold">
              Talk to our team <Icon name="arrow" sw={2} />
            </Link>
            <a
              href="#brochure"
              className="gt9-btn gt9-btn--ghost"
              style={{ boxShadow: "unset" }}
            >
              Download brochure
            </a>
          </div>
        </div>
      </section>

      {/* Fast facts */}
      <section className="gt9-facts" aria-label="Company facts">
        <div className="gt9-container">
          <div className="gt9-facts__grid">
            {FACTS.map((f) => (
              <div className="gt9-fact" key={f.label}>
                <i>
                  <Icon name={f.icon} />
                </i>
                <div>
                  <b>
                    <CountUp to={f.value} />
                    {f.suffix}
                  </b>
                  <span className="gt9-fact__l">{f.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Who we are */}
      <section className="gt9-sec" id="who">
        <div className="gt9-container">
          <div className="gt9-who">
            <div className="gt9-who__media">
              <img
                src="/assets/images/about/who.jpg"
                alt="Our engineers monitoring client systems"
                loading="lazy"
              />
              <div className="gt9-badge gt9-badge--a">
                <i>
                  <Icon name="pin" />
                </i>
                <div>
                  <b>Austin</b>
                  <span>One office, one team</span>
                </div>
              </div>
              <div className="gt9-badge gt9-badge--b">
                <i>
                  <Icon name="clock" />
                </i>
                <div>
                  <b>24/7 support</b>
                  <span>Always on, always here</span>
                </div>
              </div>
            </div>
            <div className="gt9-who__text">
              <span className="gt9-eyebrow">Who we are</span>
              <h2 className="gt9-h2">
                An IT partner that treats your business like our own
              </h2>
              <p>
                Global Tech9 LLC is an IT services company with an office in
                Austin, USA. We look after the technology that growing
                businesses depend on every day: networks, cloud, security and
                support.
              </p>
              <p>
                We started with a simple idea: IT should be dependable,
                understandable and personal. That is still how we work today.
              </p>
              <ul className="gt9-checks">
                <li>
                  <Icon name="check" sw={2} />
                  Certified engineers with hands-on experience
                </li>
                <li>
                  <Icon name="check" sw={2} />
                  Plain-language advice, never jargon for its own sake
                </li>
                <li>
                  <Icon name="check" sw={2} />
                  Support that follows the sun across USA
                </li>
              </ul>
              <Link to="/contact-us" className="gt9-btn gt9-btn--gold">
                Work with us <Icon name="arrow" sw={2} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* What we do */}
      <section className="gt9-sec gt9-sec--white" id="what">
        <div className="gt9-container">
          <div className="gt9-head gt9-head--center">
            <span className="gt9-eyebrow">What we do</span>
            <h2>Everything your business needs to run on technology</h2>
            <p>
              One team for support, cloud, security and strategy, so nothing
              falls between the cracks.
            </p>
          </div>
          <div className="gt9-cards">
            {SERVICES.map((s) => (
              <article className="gt9-svc" key={s.title}>
                <i>
                  <Icon name={s.icon} />
                </i>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
                <Link className="gt9-more" to={s.to}>
                  Learn more <Icon name="arrow" sw={2} />
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Mission and vision */}
      <section className="gt9-mv" id="mission">
        <img src="/assets/images/about/mission.jpg" alt="" loading="lazy" />
        <div className="gt9-container">
          <div className="gt9-head gt9-head--center">
            <span className="gt9-eyebrow">Our mission and vision</span>
            <h2>Where we are heading, and why</h2>
          </div>
          <div className="gt9-mv__grid">
            <article className="gt9-mvcard">
              <i>
                <Icon name="target" />
              </i>
              <h3>Our mission</h3>
              <p>
                To give every business dependable, secure and affordable IT,
                delivered by people who care about your results as much as you
                do.
              </p>
            </article>
            <article className="gt9-mvcard">
              <i>
                <Icon name="eye" />
              </i>
              <h3>Our vision</h3>
              <p>
                To be the most trusted technology partner for growing companies
                across the USA, known for service you can count on.
              </p>
            </article>
          </div>
          <div
            className="gt9-values"
            aria-label="Our values"
            style={{ border: "unset", background: "unset" }}
          >
            {VALUES.map((v) => (
              <span key={v}>{v}</span>
            ))}
          </div>
        </div>
      </section>

      {/* Why choose us */}
      <section className="gt9-sec gt9-sec--tint" id="why">
        <div className="gt9-container">
          <div className="gt9-why">
            <div className="gt9-why__intro">
              <span className="gt9-eyebrow">Why choose us</span>
              <h2 className="gt9-h2">Six reasons clients stay with us</h2>
              <p>
                We earn trust through responsiveness, honesty and work that
                holds up. Here is what that looks like in practice.
              </p>
              <Link to="/contact-us" className="gt9-btn gt9-btn--gold">
                Get in touch <Icon name="arrow" sw={2} />
              </Link>
            </div>
            <div className="gt9-why__grid">
              {WHY.map((w) => (
                <article className="gt9-feat" key={w.title}>
                  <i>
                    <Icon name={w.icon} />
                  </i>
                  <h3>{w.title}</h3>
                  <p>{w.text}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* How we work */}
      <section className="gt9-sec gt9-sec--white" id="how">
        <div className="gt9-container">
          <div className="gt9-head gt9-head--center">
            <span className="gt9-eyebrow">How we work</span>
            <h2>A simple, transparent process</h2>
            <p>Four clear steps from first conversation to ongoing support.</p>
          </div>
          <div className="gt9-steps">
            {STEPS.map((s, i) => (
              <div className="gt9-step" key={s.title}>
                <div className="gt9-step__no">{i + 1}</div>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="gt9-sec gt9-sec--tint" id="journey">
        <div className="gt9-container">
          <div className="gt9-head gt9-head--center">
            <span className="gt9-eyebrow">Our journey</span>
            <h2>How we grew</h2>
            <p>From a small team to a single-country IT partner.</p>
          </div>
          <ol className="gt9-tl">
            {TIMELINE.map((t) => (
              <li key={t.year}>
                <div className="gt9-tl__card">
                  <span className="gt9-tl__year">{t.year}</span>
                  <h3>{t.title}</h3>
                  <p>{t.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* Leadership */}
      <section className="gt9-sec gt9-sec--white" id="team">
        <div className="gt9-container">
          <div className="gt9-head gt9-head--center">
            <span className="gt9-eyebrow">Our people</span>
            <h2>Meet the leadership team</h2>
            <p>
              Experienced leaders who stay close to the work and to our clients.
            </p>
          </div>
          <div className="gt9-team">
            {TEAM.map((m) => (
              <article className="gt9-person" key={m.name}>
                <div className="gt9-person__pic">
                  {m.photo ? (
                    <img src={m.photo} alt={m.name} loading="lazy" />
                  ) : (
                    <span>{initials(m.name)}</span>
                  )}
                </div>
                <div className="gt9-person__body">
                  <h3>{m.name}</h3>
                  <span className="gt9-person__role">{m.role}</span>
                  <p>{m.bio}</p>
                  <a
                    href={m.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={`${m.name} on LinkedIn`}
                  >
                    <Icon name="linkedin" />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Brochure */}
      <section className="gt9-sec gt9-sec--tint" id="brochure">
        <div className="gt9-container">
          <div className="gt9-bro">
            <div className="gt9-bro__cover">
              <img
                src="/assets/images/about/brochure.jpg"
                alt="Global Tech9 LLC company profile brochure cover"
                loading="lazy"
              />
            </div>
            <div>
              <span className="gt9-eyebrow">Company brochure</span>
              <h2>Take our story with you</h2>
              <p>
                Download our company profile for a short overview of our
                services, our people and how we work.
              </p>
              <ul>
                {BROCHURE_POINTS.map((b) => (
                  <li key={b}>
                    <Icon name="check" sw={2} />
                    {b}
                  </li>
                ))}
              </ul>
              <a className="gt9-btn gt9-btn--gold" href={" "} download>
                Download brochure (PDF) <Icon name="download" sw={2} />
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
